import React, { Component, PropTypes } from 'react'
import {Row, Col} from 'react-flexbox-grid'
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  SignupForm,
  SrOnly,
} from '../../components'

import Styles from './AppFooter.css'


@CSSModules(Styles)
class AppFooterLink extends Component {
  static propTypes = {
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }
  constructor(props){
    super(props)
  }
  render() {
    const { url, title } = this.props
    //
    return (
      <div styleName='af-footer-link-out'>
        <Link
          to={url}
          title={title}
        >
          <div styleName='af-footer-link-in'>
            {title}
          </div>
        </Link>
      </div>
    )
  }
}

@CSSModules(Styles)
export default class AppFooter extends Component {
  static propTypes = {
    hideSiteMap: PropTypes.bool
  }
  constructor(props){
    super(props)
    this.state = {
      hideSiteMap: this.props.hideSiteMap || false,
      environmentIssueRoutes: [
        [config.routes.issueFossilFuels, 'Fossil fuels'],
        [config.routes.issueDeforestation, 'Deforestation']
      ],
      socialIssueRoutes: [
        [config.routes.issueGenderEquality, 'Gender equality'],
        [config.routes.issueCivilianFirearms, 'Civilian firearms'],
        [config.routes.issuePrisonIndustrialComplex, 'Prison industrial complex'],
        [config.routes.issueArmsManufacturers, 'Arms manufacturers'],
        [config.routes.issueTobacco, 'Tobacco']
      ],
      solutionRoutes: [
        [config.routes.solutionOfferSustainability, 'Offer sustainable investments'],
        [config.routes.solutionDefaultSustainability, 'Make the default investment sustainable'],
      ],
      dataRoutes: [
        [config.routes.plans, 'Retirement plans'],
        [config.routes.targetDateFunds, 'Target date funds'],
        [config.routes.mutualFundsETFs, 'Mutual funds and ETFs'],
        [config.routes.assetManagers, 'Asset managers'],
        [config.routes.companies, 'Companies'],
        [config.routes.howitworks, 'Methodology'],
      ],
      eduCenterRoutes: [
        [config.routes.eduCenterFinRisks, 'Financial risks of unsustainable investments'],
        // [config.routes.eduCenterEnvSocRisks, 'Environmental and social risks of unsustainable investments'],
        [config.routes.eduCenterIndividual, 'For employees'],
        [config.routes.eduCenterPlanAdmins, 'For plan administrators'],
        // [config.routes.eduCenterIndProfs, 'For financial industry professionals'],
        [config.routes.faqs, 'FAQs'],
      ]
    }
  }

  render() {
    const { environmentIssueRoutes, socialIssueRoutes, solutionRoutes,
            dataRoutes, eduCenterRoutes, hideSiteMap } = this.state

    const aysLogo = require( '../../../static/images/AsYouSow_Logo_color.svg' )

    //
    return (
      <div>
        <div styleName='af-img-bckgrnd'>
          <ContainerDivs>
           {
              hideSiteMap ?
                <div styleName='af-row0-buffer' /> :
                (
                  <nav styleName='af-row0'>
                    <Row>
                      <Col xs={12} md={4}>
                        <div styleName='af-links-label'>
                          <Link
                            to={config.routes.issues}
                            title={'The issues'}
                          >
                            The issues
                          </Link>
                        </div>
                        <div styleName='af-links-wrap'>
                          <div styleName='af-links-sublabel'>
                            Environment
                          </div>
                          {
                            environmentIssueRoutes.map((e,i)=>{
                              const [url, title] = e
                              return (
                                <AppFooterLink
                                  key={'footer-links-1-'+i}
                                  url={url}
                                  title={title}
                                />
                              )
                            })
                          }
                          <div styleName='af-links-sublabel'>
                            Social
                          </div>
                          {
                            socialIssueRoutes.map((e,i)=>{
                              const [url, title] = e
                              return (
                                <AppFooterLink
                                  key={'footer-links-1-'+i}
                                  url={url}
                                  title={title}
                                />
                              )
                            })
                          }
                        </div>
                      </Col>
                      <Col xs={12} md={4}>

                        <div styleName='af-links-label'>
                          <Link
                            to={config.routes.solutions}
                            title={'The solutions'}
                          >
                            The solutions
                          </Link>
                        </div>
                        <div styleName='af-links-wrap'>
                          {
                            solutionRoutes.map((e,i)=>{
                              const [url, title] = e
                              return (
                                <AppFooterLink
                                  key={'footer-links-2-'+i}
                                  url={url}
                                  title={title}
                                />
                              )
                            })
                          }
                        </div>

                        <div styleName='af-links-label'>
                          <Link
                            to={config.routes.data}
                            title={'The data'}
                          >
                            The data
                          </Link>
                        </div>
                        <div styleName='af-links-wrap'>
                          {
                            dataRoutes.map((e,i)=>{
                              const [url, title] = e
                              return (
                                <AppFooterLink
                                  key={'footer-links-3-'+i}
                                  url={url}
                                  title={title}
                                />
                              )
                            })
                          }
                        </div>

                      </Col>
                      <Col xs={12} md={4}>

                        <div styleName='af-links-label'>
                          <Link
                            to={config.routes.eduCenter}
                            title='Action center'
                          >
                            Action center
                          </Link>
                        </div>
                        <div styleName='af-links-wrap'>
                          {
                            eduCenterRoutes.map((e,i)=>{
                              const [url, title] = e
                              return (
                                <AppFooterLink
                                  key={'footer-links-4-'+i}
                                  url={url}
                                  title={title}
                                />
                              )
                            })
                          }
                        </div>

                      </Col>
                    </Row>
                  </nav>
                )
           }
            <SignupForm />
            <div styleName='af-row1'>
              <Row>
                { /* COLUMN 1 */ }
                <Col xs={12} md={4}>
                  <div styleName='af-col-in'>
                    <div styleName='af-col-hl'>
                      <Link
                        to={'/about'}
                        title='About us'
                      >
                        Invest your values
                      </Link>
                    </div>
                    <p styleName='af-col-p'>
                      We offer sustainable investment tools that highlight issues dealing with climate change, gender equality and more
                    </p>
                    <p styleName='af-col-p'>
                      <Link
                        to={config.routes.about}
                        title='About Invest Your Values'
                        transparentbutton
                      >
                        <span styleName='nowrap'>About us<LinkIcon/></span>
                      </Link>
                    </p>
                  </div>
                </Col>

                { /* COLUMN 2 */ }
                <Col xs={12} md={4}>
                  <div styleName='af-col-in'>
                    <div styleName='af-col-hl'>
                      <Link
                        to={config.links.donate}
                        title='Support this work'
                      >
                        Support this work
                      </Link>
                    </div>
                    <p styleName='af-col-p'>
                      Invest Your Values is funded by contributions
                      to <span styleName='nowrap'>As You Sow</span>,
                      a <span styleName='nowrap'>non-profit 501(c)3</span>.
                    </p>
                    <p styleName='af-col-p'>
                      <Link
                        to={config.links.donate}
                        title='Donate to As You Sow'
                        transparentdonatebutton
                      >
                        Donate<LinkIcon/>
                      </Link>
                    </p>
                  </div>
                </Col>

                { /* COLUMN 3 */ }
                <Col xs={12} md={4}>
                  <div styleName='af-col-in'>
                    <div styleName='af-col-hl'>
                     <Link
                      to={config.links.ays}
                      title='As You Sow'
                    >
                      <img
                        src={aysLogo}
                        alt='As You Sow'
                        styleName='af-logo'
                      />
                      <SrOnly>As You Sow</SrOnly>
                    </Link>
                    </div>

                    <p styleName='af-col-p'>
                      Invest Your Values  is a project by <i>As You Sow</i>, a 501(c)3 nonprofit empowering shareholders to change corporations for good
                    </p>
                    <p styleName='af-col-p'>
                      <Link
                        to={config.links.ays}
                        title='As You Sow'
                        transparentbutton
                      >
                        <span styleName='nowrap'>Visit As You Sow<LinkIcon/></span>
                      </Link>
                    </p>
                  </div>
                </Col>
              </Row>
            </div>

            <div styleName='af-row2'>
              <Row>
                <Col xs={12} md={8}>
                  <div styleName='af-col-hl'>
                    <Link
                      to={config.routes.legal}
                      title='Legal'
                    >
                      Legal
                    </Link> &nbsp;&nbsp;&nbsp;
                  </div>
                  <div styleName='af-col-p'>
                    &copy; Copyright {new Date().getFullYear()} As You Sow.
                    All rights reserved.
                    <br/>
                    Main Post Office, PO Box 751, Berkeley, CA 94701
                  </div>
                </Col>
                <Col xs={12} md={4}>
                  <p styleName='af-col-hl'>
                    <i>Connect with As You Sow</i>
                  </p>
                  <p styleName='af-col-p'>
                    <Link
                      to={config.links.contact}
                      title='Contact us'
                    >
                      Contact us
                    </Link>&nbsp;&nbsp;&nbsp;<Link
                      to={config.links.socialAYStwitter}
                      title='Connect with us on Twitter'
                      xstrong
                    ><LinkIcon faclass='fa-twitter' /></Link>&nbsp;&nbsp;&nbsp;<Link
                      to={config.links.socialAYSfb}
                      title='Connect with us on Facebook'
                      xstrong
                    ><LinkIcon faclass='fa-facebook-official' /></Link>
                  </p>
                </Col>
              </Row>
            </div>
          </ContainerDivs>
        </div>
      </div>
    )
  }
}